module.exports = __webpack_public_path__ + "static/media/finance-smart.c6f17d69.svg";